import { Component } from "puzzle";
import Files from "../../../Drawer/Tabs/Files/Files";
import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import {
  DOWNLOAD_PARAMS, LOADED_TARGET,
  OVERRIDE_METHODS, UPLOAD_REQUEST_PARAMS,
  URL_CONFIGS
} from "../../../Drawer/Tabs/Types";
import { DropDownButtonItemClickEvent } from "@progress/kendo-react-buttons";
import { get } from "lodash";
import WordCountLink from "../../../util/WordCountLink/WordCountLink";
import * as _ from "lodash";
import { SUPPORTED_EDITORS } from "../../../util/Util";

type PROPS = {
  detached: boolean;
  initialFilter: any;
  isSupplierView: boolean;
  submissionData: any;
  userType: string;
};

export default class SupplierFiles extends Component<PROPS, {}> {
  /**
   * Dispatches download action
   * @param downloadParams
   */
  startDownload = (downloadParams: DOWNLOAD_PARAMS): void => {
    const { submissionData } = this.props;
    let actionName = 'downloadFiles';
    let confirmActionName = '';
    let availableOrReserved = submissionData.submissionStatus === 'AVAILABLE' || submissionData.submissionStatus === 'RESERVED';
    if (availableOrReserved) {
      actionName = 'previewWarningAndDownload';
      confirmActionName = 'downloadFiles';
    }
    this.dispatch(actionName, '', {
      confirmActionName,
      submissionData,
      params: downloadParams,
      afterDownloadAction: 'refreshApp'
    });
  };

  /**
   * Localizes SupplierFiles status
   * @param value
   */
  localizeStatusCell(value: string): string {
    return this.translate('taskFileStatuses.' + value);
  }

  /**
   * Word count render
   */
  wordsCellRender = (cellProps: GridCellProps): JSX.Element => {
    const { dataItem } = cellProps;
    let wordCountText = <WordCountLink
      data={{
        submissionName: this.props.submissionData.submissionName,
        submissionId: this.props.submissionData.submissionId,
        taskId: this.props.submissionData.taskId,
        isSupplierView: true,
        ...cellProps.dataItem,
        wordCount: dataItem.words,
      }}
      onlyNumber={true}
    />
    return wordCountText;
  }

  /**
   * Complete action handler
   *
   * @param action
   * @param event
   */
  completeReturnFilesHandler(action: 'promote' | 'demote', event: DropDownButtonItemClickEvent): void {
    const { item } = event;
    const { all: selectAll = false } = item;
    const { submissionData } = this.props;
    const { taskId } = submissionData;

    this.dispatch('task_complete_jobPhase_files', '', {
      actionName: action,
      drawerDetached: this.props.detached,
      executionModuleName: this.moduleName,
      promoteFilesAction: 'completeActionWarnings',
      submissionData: this.props.submissionData,
      selectAll,
      mandatoryCompleteParams: true,
      endpointPrefix: 'SUPPLIER_COMPLETE_',
      completeSupplierURL: `/jobPhasesFiles/${taskId}/${action === 'promote' ? 'complete' : 'return'}`
    });
  }

  /**
   * Returns availableEditors for SupplierFies
   */
  getEditors = (): string[] => this.props.submissionData.availableEditors || [];

  /**
   * Conditions to determinate if fileName should be hyperlinked(Open available)
   * @param dataItem
   */
  isFileHyperlinked = (dataItem: LOADED_TARGET): boolean => {
    const { submissionData } = this.props;
    const { submissionStatus } = submissionData;
    let { nonParsable } = dataItem;
    let editor = _.get(this.getEditors(), '[0]');

    if (editor) {
      if (editor === "SIDE_BY_SIDE") {
        nonParsable = false; // in case of SxS editor ignore nonParsable property
      } else {
        editor = _.includes(SUPPORTED_EDITORS, editor);
      }
    }
    const taskStatus = get(this.props, 'submissionData.submissionStatus') !== 'AVAILABLE';
    const status = get(dataItem, 'status.name');
    const reservedAndClaimed = submissionStatus === 'RESERVED' && status === 'CLAIMED';

    return taskStatus && !nonParsable && !['COMPLETED', 'CANCELLED'].includes(status) && !!editor && !reservedAndClaimed;
  }

  /**
   * Getter for online editor adress
   */
  getOnlineEditorUrl = (): string => {
    const { submissionData } = this.props;
    const { taskId } = submissionData;

    return `/jobPhases/${taskId}/files/editor/urls`;
  };

  /**
   * Upload params getter
   */
  getUploadParams = (): UPLOAD_REQUEST_PARAMS => {
    return {
      completeActionName: 'reportDialogCompleteAllVendor',
      returnActionName: 'reportDialogReturnAllVendor',
      supplierView: true,
      uploadDialogUrl: '/jobPhases/upload',
      uploadReportGetUrl: '/jobPhases/upload/report/',
      downloadReportUrl: '/jobPhases/download/upload/report',
    }
  };

  renderBody() {
    return (
      <Files
        {...this.props}
        isSupplierView={true}
        overrideMethods={{
          wordsCellRender: this.wordsCellRender,
          startDownload: this.startDownload,
          completeReturnFilesHandler: this.completeReturnFilesHandler,
          getEditors: this.getEditors,
          isFileHyperlinked: this.isFileHyperlinked,
          getOnlineEditorUrl: this.getOnlineEditorUrl,
          getUploadParams: this.getUploadParams
        } as OVERRIDE_METHODS}
        urlConfigs={{
          filesTabUrl: '/jobPhaseFileView',
          massActionUrl: null,
          summaryInfoUrl: '/jobPhaseFileView/summaryInfo',
          searchBarInfoUrl: '/jobPhase/%getParam%/searchBarInfo',
          paramsConfig: {
            folder: 'JOB_PHASE_FILE',
            mainParam: 'taskId'
          }
        } as URL_CONFIGS}
      />

    )
  }

}